import { useWorkService } from "../../../services/work.service";
import ActiveWorkers from "./active-workers";

export default function TranscriptionReviewQueue() {
  const { getActiveReviewers, unassignReviewer, unassignAllReviewers } = useWorkService();

  return (
    <ActiveWorkers
      title="Transcription Review Queue"
      emptyMessage="No active reviewers"
      getWorkersFn={getActiveReviewers}
      unassignWorkerFn={unassignReviewer}
      unassignAllWorkersFn={unassignAllReviewers}
      supportManagerContext={false}
    />
  );
}
